import React, { useContext, useEffect, useState } from 'react'
import QuestionComponent from './QuestionComponent';
import {ReactComponent as STARS} from "../../../../assets/icons/questions-starts.svg";
import OptionsComponent from './OptionsComponent';
import { firestore } from '../../../../firebase.config';
import { DataContext } from '../../../../Context/DataContext';

export const options = [
  {
    value: "We outsource to a translation provider",
    finalText: "We’ll show you how eVerbary compares to your current provider — faster delivery, flexible billing, and legal-grade accuracy.",
    subText: `“Law firms use eVerbary to improve delivery times, collaborate as a team, and offer white-label service — boosting the firm’s authority and client trust.”`,
  },
  {
    value: "We translate documents in-house",
    finalText: "Looks like you’re managing translations internally — we’ll show you how eVerbary can save your team hours each week.",
    subText: `“Law firms use eVerbary to free up internal resources so they can focus on legal work and client service — without sacrificing control.”`,
  },
  {
    value: "We refer clients to outside translators",
    finalText: "See how eVerbary helps in simplifying how clients get their translations done — with commissions for every referral you send.",
    subText: `“Law firms use eVerbary as a trusted translation partner for their clients — while earning referral fees and ensuring quality every time.”`,
  },
  {
    value: "Our clients find translators on their own",
    finalText: "We’re building smart tools to plug into Clio, Docketwise and more.",
    subText: `“Law firms use eVerbary to offer a valuable add-on service their clients already need — simplifying the process and keeping everything in one place.”`,
  },

]

const question =  {
  title: "1. Translation Workflow",
  question: "How does your firm currently handle certified translations?",
  options: options,
}

const Ques1 = ({windowSize, currentScreen, setCurrentScreen, onContinue}) => {
    const [selectedOption, setSelectedOption] = useState(question.options[0].value);
    const {userData, teamData} = useContext(DataContext);

    useEffect(() => {
      if(userData && userData.teamId && teamData){
        const onBoarding = teamData.onBoarding;
        if(onBoarding && onBoarding.translation_workflow){
          setSelectedOption(onBoarding.translation_workflow);
        }
      }
    }, [userData, teamData])

    const onContinueQuestion = () => {
      const onBoarding = teamData.onBoarding;
      firestore.collection("teams").doc(userData.teamId).update(
        {
          onBoarding: onBoarding ? {...onBoarding, translation_workflow: selectedOption} : {translation_workflow: selectedOption}
        }).then(() => {
          onContinue();
        })
    }

    const onClickOption = (option) => {
      setSelectedOption(option.value);
    }

  return (
    <QuestionComponent
    windowSize={windowSize}
    question={question.question}
    onContinue={onContinueQuestion}
    progressTitle={question.title}
    progress={0}
    className="flex-[1]"
    subText={question.options.find(option => option.value === selectedOption)?.subText}
    subTextIcon={<STARS className='min-w-[24px] h-[24px]'/>}
    disableContinue={!teamData || !selectedOption}
  >
    <div className={`flex gap-[8px] w-full flex-wrap`}>
      {question.options.map((option, i) => <OptionsComponent option={option} className={"min-w-[290px] flex-[1]"} width={"max-sm:w-full w-max"}
      index={i}  selectedOption={selectedOption} onClickOption={onClickOption}/>)}
     </div>


  </QuestionComponent>
  )
}

export default Ques1